module.exports = __webpack_public_path__ + "img/bicycleRearRight.d4c62ca1.svg";